<template>
	<div class="wrapBox">
		<navheader current="2"></navheader>
		<div class="bannerBox"></div>
		<!-- <div class="guanliTeam teamBox">
			<div class="title">管理团队</div>
			<div class="line"></div>
			<div class="guanliBox">
				<div class="teamItemImg">
					<img :src="manageTeamList[0].photoImg" alt="" style="width: 100%;height: 100%;">
				</div>
				<div class="teamInfo">
					<div class="name">{{manageTeamList[0].doctorName}}</div>
					<div class="teamtitle">{{manageTeamList[0].title}} | {{manageTeamList[0].titleSub}}</div>
					<div class="field">{{manageTeamList[0].field}}</div>
				</div>
			</div>
			<div class="guanliBox">
				<div class="teamInfo">
					<div class="name">{{manageTeamList[1].doctorName}}</div>
					<div class="teamtitle">{{manageTeamList[1].title}} | {{manageTeamList[1].titleSub}}</div>
					<div class="field">{{manageTeamList[1].field}}</div>
				</div>
				<div class="teamItemImg">
					<img :src="manageTeamList[1].photoImg" alt="" style="width: 100%;height: 100%;">
				</div>
			</div>
		</div> -->
		<div class="yishiTeam teamBox">
			<div class="title">医师团队</div>
			<div class="line"></div>
			<div class="teamList">
				<div class="teamItem" v-for="item in doctorList" :key="item.guid">
					<div class="teamItemImg">
						<img :src="item.photoImg" alt="" style="width: 100%;height: 100%;">
					</div>
					<div class="name">{{item.doctorName}}</div>
					<div class="teamtitle">{{item.title}} | {{item.titleSub}}</div>
					<div class="field">{{item.field}}</div>
					<!-- <div class="field">潘力，1982年1月本科毕业于四川泸州医学院， 1985年9月考入华山医院神经外科研究生，1990年以优异的成绩破格获得医学博士学位并留在华山医院神经外科工作。主要从事现代立体定向技术和定向仪研究。在国内先后自行设计制造出可用于CT、MRI和普通X线定位的定向仪，并率先在国内开展了CT、MRI立体定向手术。其课《磁共振、ＣＴ立体定向手术方法与定向仪研究》获1990年中国卫生部科技成果三等奖。论文《通用多功能立体定向仪》获世界卫生组织WHO)1990年青年优秀论文一等奖。1992年晋升为上海医科大学附属华山医院神经外科副教授，同年获上海市卫生系统第四届“银蛇奖”一等奖。1993年以后，成为国内首批从事伽玛刀治疗和研究的人员。
						截今为止，已成功地为15000多例患者进行了伽玛刀治疗。1994年被批准为硕士生导师。课题《伽玛刀放射生物学研究及其临床意义》获上海市1998年科技成果三等奖。已发表科研论文80余篇，参加十余本专业参考书的编写工作。1999年晋升为上海医科大学教授，博士生导师。现任中国医师协会神经外科分会放射神经外科专家委员会主任委员，复旦大学医学院(原上海医科大学)附属华山医院神经外科副主任，复旦大学医学院附属华山医院射波刀室主任，上海伽玛医院副院长兼总经理。</div> -->
				</div>
			</div>
		</div>
		<footercommon></footercommon>
	</div>
	
</template>

<script>
	import navheader from "../components/navheader.vue";
	import footercommon from "../components/footercommon.vue";
	import {GetDoctor} from '@/api/api'
	export default{
		components: { navheader,footercommon},
		data(){
			return{
				doctorList:[],
				manageTeamList:[]
			}
		},
		mounted() {
			this.query()
		},
		methods: {
			changeList(index){
				this.cur=index
			},
			query(){
				GetDoctor({status:1,pageSize:30}).then(res => {
					console.log(res)
					this.doctorList=res.data.data.rows.filter(item => item.isHome != 1)
					this.manageTeamList=res.data.data.rows.filter(item => item.isHome == 1)
				})
			},
			
		},
	}
</script>

<style lang="scss" scoped>
	.bannerBox{
		background-image: url('../assets/images/ExpertTeambanner1.png');
		background-repeat: no-repeat;
		background-size: cover;
		background-position: center;
		height: 22.875rem;
		box-sizing: border-box;
		overflow: hidden;
	}
	.teamBox{
		padding-top: 2.5rem;
		width: $commoneWidth;
		margin: 0 auto;
		.title{
			font-size: 2rem;
			color: $baseColor;
			margin-bottom: 0.75rem;
		}
		.line{
			width: 4rem;
			height: 0.2rem;
			background-color: #0C9F96;
		}
	}
	.teamList{
		display: flex;
		flex-wrap: wrap;
		justify-content: flex-start;
		margin-left: 3rem;
		.teamItem{
			margin-top: 2rem;
			width: 33.33%;
			height: 100%;
			
			margin-bottom: 1.25rem;
			.teamItemImg{
				width: 21.875rem;
				height: 17.5rem;
				img{
					width: 100%;
				}
			}
			.name{
				font-size: 2rem;
				color:#444;
				margin-top: 0.5rem;
			}
			.teamtitle{
				font-size: 1.1rem;
				color:$baseColor;
				margin-top: 0.5rem;
			}
			.field{
				font-size: 1.1rem;
				color:#999;
				margin-top: 0.5rem;
				width: 21.875rem;
				overflow: hidden;
				text-overflow: ellipsis;
				white-space: normal;
				display: -webkit-box;
				-webkit-line-clamp: 3;
				-webkit-box-orient: vertical;
				text-align: justify;
			}
		}
		
	}
	.guanliTeam{
		.guanliBox{
			margin-top: 2.5rem;
			display: flex;
			background: #F7FBFB;
			.teamItemImg{
				width: 32.5rem;
				height: 26.25rem;
			}
			.teamInfo{
				margin-left: 4rem;
				width: 45rem;
				margin-top: 4rem;
				.name{
					font-size: 2rem;
					color:#444;
					margin-top: 0.5rem;
				}
				.teamtitle{
					font-size: 1.1rem;
					color:$baseColor;
					margin-top: 0.5rem;
				}
				.field{
					font-size: 1.1rem;
					color:#999;
					margin-top: 0.5rem;
					text-align: justify;
				}
			}
			
		}
		
	}
	@media screen and (max-width: 768px) {//手机版本
		.bannerBox{
			background-size: 100%;
			height: 127px;
		}
		.teamBox{
			padding:20px 10px;
			width: 100%;
			.title{
				font-size: 16px;
				color: $baseColor;
				margin-bottom: 6px;
			}
			.line{
				width: 32px;
				height: 2px;
			}
		}
		.teamList{
			display: flex;
			flex-wrap: wrap;
			justify-content: flex-start;
			margin-left: 0;
			.teamItem{
				margin-top: 10px;
				width: 50%;
				margin-bottom: 1.25rem;
				.teamItemImg{
					width: 60px;
					height: 50px;
					img{
						width: 100%;
					}
				}
				.name{
					font-size: 18px;
					margin-top: 5px;
				}
				.teamtitle{
					font-size: 12px;
					margin-top: 5px;
				}
				.field{
					font-size: 12px;
					margin-top: 5px;
					width: 90%;
					overflow: hidden;
					text-overflow: ellipsis;
					white-space: normal;
					display: -webkit-box;
					-webkit-line-clamp: 3;
					-webkit-box-orient: vertical;
					text-align: justify;
				}
			}
			
		}
		.guanliTeam{
			.guanliBox{
				margin-top: 10px;
				display: flex;
				background: #F7FBFB;
				.teamItemImg{
					width: 100px;
					height: 80px;
					flex-shrink: 0;
				}
				.teamInfo{
					margin-left:10px;
					margin-top: 0;
					.name{
						font-size: 18px;
						margin-top: 10px;
					}
					.teamtitle{
						font-size: 12px;
						margin-top: 5px;
					}
					.field{
						font-size: 12px;
						margin-top: 5px;
					}
				}
				
			}
			
		}
	}
		
</style>